import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RegisterService} from '../shared/services/register.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  verifier: boolean;
  password: string;
  currentDate = new Date();
  minPasswordLength = false;
  idUser: number;
  token: string;
  isRequest = true;
  reseted = false;
  passwordPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@#$!%*?&_-])[A-Za-z\\d#@$!%*?&-_]{8,}$';

  constructor( private registerService: RegisterService,
               public router: Router, private fb: FormBuilder, private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      if (params.token === undefined) {
        this.isRequest = true;
      } else {
        this.isRequest = false;
        this.idUser = params.idUser;
        this.token = params.token;
      }
    });
  }

  ngOnInit() {
    this.inForm();
  }

  private inForm() {
    if (this.isRequest) {
      this.resetPasswordForm = this.fb.group({
        confirmPassword: [null],
        password: [null],
        email: [null, [Validators.required, Validators.email]]
      }, {validator: this.matchPasswords('password', 'confirmPassword')});
    } else {
      this.resetPasswordForm = this.fb.group({
        confirmPassword: [null, Validators.required],
        password: [null, [Validators.required, Validators.pattern(this.passwordPattern)]],
        email: [null]
      }, {validator: this.matchPasswords('password', 'confirmPassword')});
    }
  }
  get f() {
    return this.resetPasswordForm.controls;
  }

  reset() {
    this.verifier = true;
    if (!this.resetPasswordForm.valid) {
      return;
    }
    this.registerService.resetPassword({
      id: this.idUser,
      token: encodeURIComponent(this.token),
      password: this.resetPasswordForm.value.password
    }).subscribe(r => {
      console.log(r);
      this.reseted = true;
     // this.router.navigate(['/login']);
    });
  }

  resetRequest() {
    this.verifier = true;
    if (!this.resetPasswordForm.valid) {
      return;
    }
    this.registerService.askResetPassword({
      email: this.resetPasswordForm.value.email,
      fiscalCode: this.resetPasswordForm.value.fiscalCode
    }).subscribe(r => {
    });
  }

  matchPasswords( controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({mustMatch: true});
      } else {
        matchingControl.setErrors(null);
      }
    };
    // this.minPasswordLength = false;
    // const control = this.resetPasswordForm.controls.password;
    // const matchingControl = this.resetPasswordForm.controls.confirmPassword;
    // if (control.value == null || control.value === '') {
    //   matchingControl.setValue('');
    //   return;
    // }
    // if (control.value.length < 6) {
    //   this.minPasswordLength = true;
    //   return;
    // }
    // this.verifierPassword = true;
    // if (control.value !== matchingControl.value) {
    //   matchingControl.setErrors({mustMuch: true});
    //   return;
    // } else {
    //   matchingControl.setErrors(null);
    // }
    // this.verifierPassword = false;
  }
}
